import { useUpdateFlow } from '../../api/useUpdateFlow'
import { Button, Text } from '@mantine/core'
import { FaultStatus } from '../../api/fault.types'

export function PreAcceptedForm({
  id,
  status,
}: {
  id: number
  status?: FaultStatus
}) {
  const { updateFlow } = useUpdateFlow(id)
  return (
    status === FaultStatus['pre-accepted'] && (
      <>
        <Text size='xs' mt={4}>
          Czy chcesz zaakceptować?
        </Text>
        <Button
          mt='md'
          mr='md'
          variant='filled'
          color='teal'
          onClick={() => updateFlow({ flow: 2, decision: 'accepted' })}
        >
          Zaaakceptuj
        </Button>
        <Button
          mt='md'
          mr='md'
          variant='filled'
          color='red'
          onClick={() => updateFlow({ flow: 2, decision: 'rejected' })}
        >
          Odrzuć
        </Button>
      </>
    )
  )
}
